import React from 'react';
import { Form, Select, Typography } from 'antd';
import filterConnect from '../../../../../../common/hoc/filterConnect';

const Option = Select.Option;

const Role = ({
  isEditable,
  validateField,
  form,
  roles,
  profileStatus,
  profileStatusKey,
}) => {
  const { getFieldDecorator } = form;
  const validateRole = validateField(isEditable ? 'roleKey' : 'role');

  return (
    <div className="b-form-fields b-form-fields_role">
      <div className="b-form-fields__item">
        <Form.Item
          label="Должность"
          validateStatus={validateRole.status}
          help={validateRole.help}
        >
          {getFieldDecorator('roleKey', {
            rules: [
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(
            <Select
              style={{ width: 224 }}
              name="roleKey"
              placeholder="Выберите должность"
              disabled={!isEditable}
              getPopupContainer={trigger => trigger.parentNode}
            >
              {roles &&
                roles.map(item => {
                  if (
                    (!isEditable && item.roleId > 1) ||
                    (isEditable && item.roleId > 2)
                  ) {
                    return (
                      <Option key={item.roleKey} value={item.roleKey}>
                        {item.role}
                      </Option>
                    );
                  }
                  return null;
                })}
            </Select>
          )}
          {!isEditable && profileStatus && profileStatusKey !== 'active' && (
            <Typography.Text
              style={{ marginLeft: 16 }}
              type={profileStatusKey === 'wait' ? 'secondary' : 'danger'}
            >
              {profileStatus}
            </Typography.Text>
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default filterConnect(Role, ['roles']);
